export default __webpack_public_path__ + "static/media/road-closures.dadb500a.svg";